<div class="ai-dialog-content">
    <ng-content></ng-content>
</div>
